var map = {
	"./Corteva_Do_More_with_Less-desktop.jpg": 278,
	"./Corteva_Do_More_with_Less-mobile.jpg": 279,
	"./Corteva_Do_More_with_Less-tablet.jpg": 280,
	"./Corteva_From_Data_to_Decision-desktop.jpg": 281,
	"./Corteva_From_Data_to_Decision-mobile.jpg": 282,
	"./Corteva_From_Data_to_Decision-tablet.jpg": 283,
	"./Corteva_How_the_world_grows_TMT-CORT003-120-desktop.jpg": 284,
	"./Corteva_How_the_world_grows_TMT-CORT003-120-mobile.jpg": 285,
	"./Corteva_How_the_world_grows_TMT-CORT003-120-tablet.jpg": 286,
	"./Farming_where_it_doesnt_rain_tablet.png": 287,
	"./TMT-CORT010-120-desktop.jpg": 288,
	"./TMT-CORT010-120-mobile.jpg": 289,
	"./TMT-CORT010-120-tablet.jpg": 290,
	"./Tanzania-Queen-and-Son-small-desktop.jpg": 291,
	"./Tanzania-Queen-and-Son-small-mobile.jpg": 292,
	"./Tanzania-Queen-and-Son-small-tablet.jpg": 293,
	"./Thailand-desktop.jpg": 294,
	"./Thailand-mobile.jpg": 295,
	"./Thailand-tablet.jpg": 296,
	"./art-of-precision.jpg": 297,
	"./brasil_new_pastures-desktop.jpg": 298,
	"./brasil_new_pastures-mobile.jpg": 299,
	"./brasil_new_pastures-tablet.jpg": 300,
	"./cracking-the-code-desktop.jpg": 301,
	"./cracking-the-code-mobile.jpg": 302,
	"./cracking-the-code-tablet.jpg": 303,
	"./seeds-of-change-desktop.jpg": 304,
	"./seeds-of-change-mobile.jpg": 305,
	"./seeds-of-change-tablet.jpg": 306,
	"./silicon-farm-poster-desktop.jpg": 307,
	"./silicon-farm-poster-mobile.jpg": 308,
	"./silicon-farm-poster-tablet.jpg": 309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 522;